import { RoutePreset } from '../types/fare';

/**
 * Quick route presets for one-click fare calculation
 * These are popular tourist routes in Sri Lanka
 */
export const QUICK_ROUTE_PRESETS: RoutePreset[] = [
  {
    id: 'airport-colombo',
    name: 'Airport → Colombo',
    description: 'Bandaranaike International Airport to Colombo Fort',
    start: { lat: 7.180756, lng: 79.884117 },  // Airport
    end: { lat: 6.933608, lng: 79.849647 },    // Colombo Fort
    distanceKm: 35
  },
  {
    id: 'colombo-airport',
    name: 'Colombo → Airport',
    description: 'Colombo Fort to Bandaranaike International Airport',
    start: { lat: 6.933608, lng: 79.849647 },  // Colombo Fort
    end: { lat: 7.180756, lng: 79.884117 },    // Airport
    distanceKm: 35
  },
  {
    id: 'colombo-galle',
    name: 'Colombo → Galle',
    description: 'Colombo to Galle Fort via Southern Expressway',
    start: { lat: 6.9271, lng: 79.8612 },      // Colombo
    end: { lat: 6.0535, lng: 80.2210 },        // Galle
    distanceKm: 119
  },
  {
    id: 'colombo-ella',
    name: 'Colombo → Ella',
    description: 'Colombo to Ella scenic hill country route',
    start: { lat: 6.9271, lng: 79.8612 },      // Colombo
    end: { lat: 6.8667, lng: 81.0467 },        // Ella
    distanceKm: 197
  }
];

/**
 * Get preset by ID
 */
export function getPresetById(id: string): RoutePreset | undefined {
  return QUICK_ROUTE_PRESETS.find(preset => preset.id === id);
}

/**
 * Sri Lanka map center and default zoom
 */
export const SRI_LANKA_CENTER = {
  lat: 7.8731,
  lng: 80.7718
};

export const DEFAULT_ZOOM = 8;
export const CITY_ZOOM = 13;
export const ROUTE_ZOOM = 10;

/**
 * Sri Lanka geographic bounds for map
 */
export const SRI_LANKA_BOUNDS = {
  north: 9.835,
  south: 5.916,
  east: 81.879,
  west: 79.521
};

